import { createFileRoute } from "@tanstack/react-router"
import { SegmentsGroupsList } from "modules/segments/components/SegmentGroupsList"

export const Route = createFileRoute("/_base/_auth/customers/segments/list")({
  component: SegmentsGroupsList,
})
